import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  label: '注册用户 (Users)',
  value: '50,000+',
  suffix: '位'
}, {
  label: '认证技师 (Therapists)',
  value: '2,000+',
  suffix: '名'
}, {
  label: '月服务次数 (Monthly)',
  value: '10,000+',
  suffix: '次'
}, {
  label: '专业经验 (Experience)',
  value: '20+',
  suffix: '年'
}];
export function StatsBar() {
  return <section className="py-16 bg-[#2D5A3D] text-[#FDF8F0]" data-id="element-162">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-163">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 text-center" data-id="element-164">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="p-4" data-id="element-165">
              <div className="text-4xl md:text-5xl font-serif font-bold text-[#C9A96E] mb-2" data-id="element-166">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-[#FDF8F0]/80 font-medium tracking-wide uppercase" data-id="element-167">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}